<div class="card m-3">
  <div class="row no-gutters">
    <div class="col-md-7">
      <div class="card-body p-0">
        <div class="form-group m-2">
          <input (input)="filterList()" [(ngModel)]="templateFilter" type="text" class="form-control" id="templateFilter" placeholder="Filter by name">
        </div>

        <div *ngIf="paginatedTemplates.length > 0">
          <app-object-template *ngFor="let item of paginatedListDisplay"
              [objectTemplate]="item"
              [selectedObjectTemplate]="previewObjectTemplate$ | async"
              (selectObjectTemplateEvent)="handleSelectedObjectTemplate($event)"></app-object-template>
        </div>
        
      </div>
    </div>
    <div class="col-md-5 p-2" style="display: flex;justify-content: center;align-items: center;">
      <!-- todo: extract in a component -->
      <img *ngIf="(templateImage$ | async) as templateImage; else preview"
           [src]="templateImage"
           class="cover-img"
           alt="imagine">

    </div>
  </div>
  <div class="card-footer bg-transparent d-flex align-items-center border-top-0">
    <div class="flex-grow-1 text-center d-flex justify-content-center">

      <pagination *ngIf="paginatedTemplates.length > 0"
        [collectionSize]="paginatedTemplates.length"
        [page]="1"
        [pageSize]="5"
        [maxSize]="3"
        [allData]="paginatedTemplates"
        (listPagination)="getListPagination($event)"
      ></pagination>

    </div>
    <button #insertTemplateButton
            class="btn btn-primary"
            type="button"
            [disabled]="paginatedTemplates.length < 1 || !(hasPreviewObjectTemplateSelected$ | async)">Inserisci</button>
  </div>
</div>

<ng-template #preview>
  <p class="text-center mt-4">Seleziona template</p>
</ng-template>